import React from 'react';
import Select from 'react-select';
import { SelectionValue } from '@components/library/inputs/Input.props';
import { Portal, Privacy } from '@api/v4/private/PortalTypes';

interface PortalFormStage2Props {
  portal: Portal;
  setPortal: SetStateDispatch<Portal>;
  stage: number;
}

const PortalFormStage2: React.FunctionComponent<PortalFormStage2Props> = ({
  portal,
  setPortal,
  stage,
}) => {
  if (stage !== 2) { return null; }

  return (
    <div>
      <h3 className="portal-form-modal__title">{t('Privacy Settings')}</h3>
      <Select
        className="portal-form-modal__privacy-dropdown"
        options={[
          { value: Privacy.Public, label: t("Public") },
          { value: Privacy.Private, label: t("Private") },
          { value: Privacy.Stealth, label: t("Stealth (Extra Private)") },
        ]}
        onChange={(option: SelectionValue): void => {
          const privacy = option.value as Privacy;
          setPortal((prevState): Portal => ({ ...prevState, privacy }));
        }}
        value={portal.privacy}
      />
      <h3 className="portal-form-modal__privacy-title bold-label-styling">{t('Public')}</h3>
      <p>{t('Anyone can access this Brand Portal')}.</p>
      <h3 className="portal-form-modal__privacy-title bold-label-styling">{t('Private')}</h3>
      <p>{t('This Brand Portal is only accessible to the users you specify')}.</p>
      <h3 className="portal-form-modal__privacy-title bold-label-styling">{t('Stealth (Extra Private)')}</h3>
      <p>{t('This Brand Portal is only accessible to the users you specify, and will not show up in Google search results and other areas of Brandfolder')}.</p>
    </div>
  );
};

export default PortalFormStage2;
